<template>
  <ZoButton
    v-close-popper="!!button.closePopper"
    :class="button.class"
    :qa-id="button.qaId"
    :data-testid="button.dataTestid"
    :mode="button.mode"
    :size="button.size"
    :label="button.label"
    :disabled="button.disabled"
    :theme-color="button.themeColor"
    @clicked="clicked"
  />
</template>

<script>
import { debounce } from 'lodash';

import ZoButton from '@/components/form-controls/Button.vue';

export default {
  components: {
    ZoButton,
  },

  props: {
    button: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['clicked'],
  methods: {
    // @TODO HACK!! using debounce, We need to achieve with native Vue mechanisms - Doship, sprint 10.4 short sprint

    // eslint-disable-next-line func-names
    clicked: debounce(function (event) {
      this.$emit('clicked', event, this.button);
    }, 500, { leading: true, trailing: false }),
  },
};
</script>
